import * as React from 'react';
import { addressDataToString, IAddressData } from '../../../ui-toolkit/orders/interfaces/IAddressResponse';

interface IPriceText {
  address: IAddressData | null;
  children?: React.ReactNode;
}

const PropertyAddress: React.FC<IPriceText> = (props) => {
  let addressText = 'None';
  try {
    addressText = props.address === null ? 'None' : addressDataToString(props.address);
  } catch (e: any) {
    throw new Error('property address is incorrect');
  }

  return <span>{addressText}</span>;
};

export default PropertyAddress;
